<div class="wrapper">
  <span>{{ 'DIALOGS.UNINSTALL_DEVICE' | translate }}</span>

  <div class="button-block">
    <button type="button" mat-raised-button color="accent" [mat-dialog-close]="'vehicleKeep'" data-testid="btn-uninstall-keep">
      {{ 'DIALOGS.VEHICLE_ACTIONS.KEEP' | translate }}
    </button>
    <button type="button" mat-raised-button color="accent" [mat-dialog-close]="'vehicleArchive'" data-testid="btn-uninstall-archive">
      {{ 'DIALOGS.VEHICLE_ACTIONS.ARCHIVE' | translate }}
    </button>
    <button type="button" mat-raised-button color="accent" [mat-dialog-close]="'vehicleDelete'" data-testid="btn-uninstall-delete">
      {{ 'DIALOGS.VEHICLE_ACTIONS.DELETE' | translate }}
    </button>
    <button type="button" mat-raised-button [mat-dialog-close]="false" data-testid="btn-dialog-cancel">
      {{ 'BUTTONS.CANCEL' | translate }}
    </button>
  </div>
</div>
